import React, { Component } from 'react'
import { Box, Button, Drawer, Stack, Tooltip, Divider, Typography, TextField, Modal, FormControl, RadioGroup, FormControlLabel, Radio, Autocomplete } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { withTranslation } from 'react-i18next';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { ImagePaths } from '../../../Utility/ImagePaths';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { CheckAccessFunc, AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions';
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import { DateTime } from 'luxon';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { CurrencySymbol } from '../../../Utility/Constants';
import EditStockPopUp from '../PharmacySettings/EditStockPopUp';

let RoleData = null;
let userAccess = null;
class PharmaStockList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      pageSize: 10,
      rowCount: 0,
      StockList: [],
      FilterDatas: {
        "FromDate": DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        "ToDate": DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      },
      drug_name: "",
      isEditStockPopUp: false,
      SelectedDurg: {},
      isForViewOnly: false,
      DrugTypeFilter : "active",
      subLocData: [],
      subLocation: null,
      phList: [],
      phName: null,
      isMainPharma: false,
      physicalBoxNo : "",
    }
  }

  componentDidMount() {
    RoleData = localGetItem("loggedInUserInfo") === null ? {} : JSON.parse(localGetItem("loggedInUserInfo"));
    userAccess = CheckAccessFunc(RoleData?.pharmacy_type === 'Inhouse Pharmacy'? "Pharmacy" : "Standalone Pharmacy", "Inventory", 'Stock List', null, "Tab");
    this.setState({
      isMainPharma: RoleData?.is_main_pharmacy
    })
    this.getStockList()
    this.getSubLocData()
    this.getPharmacyData()
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  getSubLocData = () => {
    try {
      this.LoaderFunction(true);
      RestAPIService.getAll(`${Serviceurls.PHARMA_SUB_LOCATION}`)
        .then((response) => {
          if (response.data.status === "success") {
            this.LoaderFunction(false);
            this.setState({
              subLocData: response.data.data ? response.data.data.filter((item) => item.is_active == true) : [],
            })
          }
        }).catch((error) => {
          this.LoaderFunction(false);
          if (error?.response?.data?.status === 'fail') {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.LoaderFunction(false);
      this.errorMessage(error.message)
    }
  }

  getPharmacyData = () => {
    try {
        this.LoaderFunction(true)
        RestAPIService.getAll(Serviceurls.PHA_BRANCH_TOLOC)
            .then((response) => {
                if (response.data.status === 'success') {
                    this.LoaderFunction(false)
                    this.setState({
                        phList: response.data.data
                    })
                }

            }).catch((error) => {
                if (error?.response?.data?.message) {
                    this.LoaderFunction(false)
                    this.errorMessage(error.response.data.message)
                } else {
                    this.LoaderFunction(false)
                    this.errorMessage(error.message)
                }
            })
    } catch (error) {
        this.LoaderFunction(false)
        this.errorMessage(error.message)
    }
}

  getStockList = () => {
    try {
      this.LoaderFunction(true);
      let phID = this.state.phName ? this.state.phName.pharmacy_id : ''
      let subLocID = this.state.subLocation ? this.state.subLocation.id : ''
      let drugName = this.state.drug_name ? (this.state.drug_name?.replaceAll('&','%26')).replaceAll(',',' ') : ""
      let DrugTypeFilter = this.state.DrugTypeFilter === 'all' ? "" : (this.state.DrugTypeFilter === 'active' ? "&is_active=true" : "&is_active=false")
      let url = ''
      if(phID){
        url = `${Serviceurls.LIST_STOCK}?page=${this.state.page + 1}&page_size=${this.state.pageSize}&search=${drugName}&order=${"brand_name"}&pharmacy_id=${phID}${DrugTypeFilter}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}`
      }else if(subLocID){
        url = `${Serviceurls.PHARMACY_SUBLOC_STOCKLIST}?page=${this.state.page + 1}&page_size=${this.state.pageSize}&sublocation_id=${subLocID}&brand_name=${drugName}${DrugTypeFilter}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}`
      }else{
        url = `${Serviceurls.LIST_STOCK}?page=${this.state.page + 1}&page_size=${this.state.pageSize}&search=${drugName}&order=${"brand_name"}&pharmacy_id=${phID}${DrugTypeFilter}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}`
      }
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === "success") {
            this.LoaderFunction(false);
            if(subLocID){
              this.setState({
                StockList: response.data ? response.data.data : [],
                rowCount: response.data?.page_count
              })
            }else{
              this.setState({
                StockList: response.data ? response.data.data.result : [],
                rowCount: response.data.data?.total_count
              })
            }
          }
        }).catch((error) => {
          if (error?.response?.data?.status === 'fail') {
            this.LoaderFunction(false);
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false);
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  closeFilter = () => {
    this.setState({ FilterOpen: false })
  }

  renderFilterScreen = () => {
    const { t } = this.props;
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
          <Button emed_tid='st_close' onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className='eMed_rts_middle'>
          {this.state.subLocData.length > 0 ? <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              disabled={this.state.phName?.pharmacy_id}
              options={this.state.subLocData}
              getOptionLabel={(option) => (option?.sublocation_name)}
              value={this.state.subLocation}
              onChange={(event, newValue) => {
                this.setState({ subLocation: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('Select Sub Location')}
                />
              )}
            />
          </Box> : null}
          {this.state.isMainPharma && this.state.phList.length > 0 ? <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              options={this.state.phList}
              disabled={this.state.subLocation?.id}
              getOptionLabel={(option) => (option?.pharmacy_name)}
              value={this.state.phName}
              onChange={(event, newValue) => {
                this.setState({ phName: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('Select Pharmacy')}
                />
              )}
            />
          </Box>: null}
          <Box className='eMed_rts_dropdown'>
            <TextField
              size='small'
              Autocomplete="off"
              value={this.state.physicalBoxNo}
              sx={{ width: "20vw" }}
              inputProps={{ maxLength: 150 }}
              label={"Physical Box No"}
              onChange={(e) => {
                this.setState({ physicalBoxNo: e.target.value })
              }}
            />

          </Box>
        </Box>
        <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
          <Button emed_tid='fil_clear' variant='outlined' size="small"
            onClick={() => {
              this.setState({
                subLocation: null,
                phName: null,
                physicalBoxNo : "",
              }, () => this.getStockList())
            }}
            id="eMed_Config_btn">{t("Clear")}</Button>
          <Button emed_tid='fil_search' variant='contained' size="small"
            onClick={() => {
              this.getStockList()
              this.setState({ FilterOpen: false })
            }}
            id="eMed_Config_btn">{t("Search")}</Button>
        </Stack>
      </Box>
    )
  }

  gridToolBar = () => {
    const {t} = this.props;
    // let TextArray = [
    //   { label: "From Date", value: formatDate(this.state.FilterDatas.FromDate) },
    //   { label: "To Date", value: formatDate(this.state.FilterDatas.ToDate) }
    // ]
    let filterName = this.state.subLocation?.sublocation_name ? this.state.subLocation?.sublocation_name : this.state.phName?.pharmacy_name ? this.state.phName?.pharmacy_name : ''
    return (
      <Box>
        <CommonGridToolBarWithFilterText FName={filterName}  searchHolder = {t("searchBrandName")}/>
      </Box>
    )
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
    })
  }

  formatDate(input) {
    let datePart = input.match(/\d+/g),
      year = datePart[0].substring(0),
      month = datePart[1], day = datePart[2];

    return month + '-' + year;
  }

  printStockList = () => {
    try {
      this.setState({disableBtn: true})
      let phID = this.state.phName ? this.state.phName.pharmacy_id : ''
      let subLocID = this.state.subLocation ? this.state.subLocation.id : ''
      let DrugTypeFilter = this.state.DrugTypeFilter === 'all' ? "" : (this.state.DrugTypeFilter === 'active' ? "&is_active=true" : "&is_active=false")
      let url = ''
      if(phID){
        url = `${Serviceurls.LIST_STOCK}?search=${''}&order=${"brand_name"}&pharmacy_id=${phID}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}&export=${"pdf"}${DrugTypeFilter}`
      }else if(subLocID){
        url = `${Serviceurls.PHARMACY_SUBLOC_STOCKLIST}?sublocation_id=${subLocID}&brand_name=${""}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}&export_type=${"pdf"}${DrugTypeFilter}`
      }else{
        url = `${Serviceurls.LIST_STOCK}?search=${''}&order=${"brand_name"}&pharmacy_id=${phID}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}&export=${"pdf"}${DrugTypeFilter}`
      }
      RestAPIService.getAll(url).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({disableBtn: false})
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMessage(error.response?.data?.message);
          } else {
            this.errorMessage(error.message);
          }
          this.setState({disableBtn: false})
        })
    } catch (error) {
      this.errorMessage(error.message)
      this.setState({disableBtn: false})
    }
  }

  getStockListExcel = () => {
    const { t } = this.props;
    try {
      this.setState({disableBtn: true})
      let phID = this.state.phName ? this.state.phName.pharmacy_id : ''
      let subLocID = this.state.subLocation ? this.state.subLocation.id : ''
      let DrugTypeFilter = this.state.DrugTypeFilter === 'all' ? "" : (this.state.DrugTypeFilter === 'active' ? "&is_active=true" : "&is_active=false")
      let url = ''
      if(phID){
        url = `${Serviceurls.LIST_STOCK}?search=${''}&order=${"brand_name"}&pharmacy_id=${phID}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}&export=${"excel"}${DrugTypeFilter}`
      }else if(subLocID){
        url = `${Serviceurls.PHARMACY_SUBLOC_STOCKLIST}?sublocation_id=${subLocID}&brand_name=${""}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}&export_type=${"excel"}${DrugTypeFilter}`
      }else{
        url = `${Serviceurls.LIST_STOCK}?search=${''}&order=${"brand_name"}&pharmacy_id=${phID}&physical_box_no=${this.state.physicalBoxNo ? this.state.physicalBoxNo : ""}&export=${"excel"}${DrugTypeFilter}`
      }
      RestAPIService.excelGet(url).
        then((response) => {
          if (response.data) {
            var pom = document.createElement('a');
            var csvContent = response.data; //here we load our csv data 

            let filename = response.headers["content-disposition"].split("filename=")[1]

            var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
            pom.click();
            this.setState({disableBtn: false})
          }
        }).catch((error) => {
          this.errorMessage(error.response.data?.message)
          this.setState({disableBtn: false})
        })
    } catch (error) {
      this.errorMessage(t("PrintError"))
      this.setState({disableBtn: false})
    }
  }

  onFilterChange = (filterModel) => {
    if(filterModel?.quickFilterValues[0]?.length >= 2 || filterModel?.quickFilterValues?.length === 0 ){
      this.setState({
        drug_name: filterModel?.quickFilterValues[0] ? filterModel?.quickFilterValues.join() :""
      }, () =>  {
        this.getStockList();
      })
    }
  }
  
  onStockEditClose() {
    this.setState({
      isEditStockPopUp: false,
      SelectedDurg: {},
      isForViewOnly: false
    })
  }

  renderStockEditPopUp = () => {
    const { t } = this.props
    return (
      <Modal open={this.state.isEditStockPopUp}>
        <EditStockPopUp SelectedDurg={JSON.stringify(this.state.SelectedDurg)} PopUpclose={this.onStockEditClose.bind(this)} isForViewOnly={this.state.isForViewOnly} />
      </Modal>
    )
  }

  render() {
    let Settings = localGetItem("PharmaSettings") === null ? {} : JSON.parse(localGetItem("PharmaSettings"))
    let RoleData = localGetItem("loggedInUserInfo") === null ? {} : JSON.parse(localGetItem("loggedInUserInfo"))
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const showPaymentStatusColumn = loggedInUserInfo?.permission_access?.common?.restrict_payment_status !== true
    this.state.StockList.forEach((element, index) => { 
      let page = this.state.page 
      let pageSize = this.state.pageSize
      let serial = (page * pageSize) + (index + 1) 
      element.serial = serial
      // element.sno = (index + 1)
     })
    const { t } = this.props
    const columns = [
      { field: 'serial', headerName: t('SNo'), sortable: false, flex: 0.05 },
      // { field: 'id', headerName: t("StockID"), flex: 0.08, headerAlign: "center", align: "center" }, // comment for sublocation and pharmacy drug filter 19/10/24
      {
        field: 'brand_name', headerName: t('BrandName'), flex: 0.121,
        renderCell: (params) => (<div>{params?.row?.brand_name?.length > 14 ? <Tooltip placement="top" title={params?.row?.brand_name} arrow><div>{params?.row?.brand_name.slice(0, 14) + "..."}</div></Tooltip> : params?.row?.brand_name}</div>)
      },
      {
        field: 'generic_name', headerName: t('GenericName'), flex: 0.121,
        renderCell: (params) => (<div>{params?.row?.generic_name?.length > 12 ? <Tooltip placement="top" title={params?.row?.generic_name} arrow><div>{params?.row?.generic_name.slice(0, 12) + "..."}</div></Tooltip> : params?.row?.generic_name}</div>)
      },
      {
        field: 'dosage_type', headerName: t('DosageType'), flex: 0.111,
        renderCell: (params) => (<div>{params?.row?.dosage_type?.length > 12 ? <Tooltip placement="top" title={params?.row?.dosage_type} arrow><div>{params?.row?.dosage_type.slice(0, 12) + "..."}</div></Tooltip>
          : params?.row?.dosage_type ? params?.row?.dosage_type : "-"}</div>)
      },
      {
        field: 'dosage_strength', headerName: t('DosageStrength'), flex: 0.125, headerAlign: "center", align: "center",
        renderCell: (params) => <div>{params?.row?.dosage_strength?.length > 13 ? <Tooltip placement="top" title={params?.row?.dosage_strength} arrow><div>{params?.row?.dosage_strength.slice(0, 13) + "..."}</div></Tooltip>
          : params?.row?.dosage_strength ? params?.row?.dosage_strength : "-"}</div>
      },
      { field: 'batch_no', headerName: t('BatchNo'), flex: 0.122, headerAlign: "center", align: "center" },
      { field: 'stock_in_quantity', headerName: t('Quantity'), flex: 0.10, type: "number" },
      {
        field: 'expiry_date', headerName: t('ExpiryDate'), flex: 0.11, headerAlign: "center", align: "center",
        renderCell: (params) => (<div>{params.row.expiry_date ? params.row.expiry_date : "-"}</div>)
      },
      { field: 'physical_box_no', headerName: t('Box No'), flex: 0.08, type: "number" },
      ...(showPaymentStatusColumn ? [{
        field: 'mrp_per_quantity', headerName: t(`MRP/Qty (${CurrencySymbol})`), flex: 0.095, type: "number",
        renderCell: (params) => <div>{AmountFormat(params?.row?.mrp_per_quantity || 0)?.replace(`${CurrencySymbol}`, "")}</div>
      }] : []),
      {
        field: "action", flex: 0.09, headerName: t("Action"), headerAlign: "center", align: "center", sortable: false,
        renderCell: (params) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
         {/* {userAccess?.editAccess ? <Tooltip title={t("Return Stock")} placement="top" arrow>
            <Button emed_tid={'st_edit_' + params?.id} className='eMed_usrconf_btn' onClick={() => { 
              this.props.history.push({
                pathname: "/PharmacyInventory/StockList/StockReturn",
                state: {
                  isReturn: true,
                  stockId: params?.row?.id
                }
              })
            }}>
              <img src={ImagePaths.ReturnDrugOn.default} alt="Return" className='eMed_action_img' />
            </Button>
          </Tooltip> : null} */}
          <Tooltip title={t("View Stock")} placement="top" arrow>
            <Button emed_tid={'st_view_'+ params?.id} className='eMed_usrconf_btn' onClick={() => { 
              //  this.props.history.push({
              //   pathname: "/PharmacyInventory/StockList/StockReturn",
              //   state: {
              //     isReturn: false,
              //     stockId: params?.row?.id
              //   }
              // })
              this.setState({
                isEditStockPopUp: true, SelectedDurg: params?.row, isForViewOnly: true
              })
            }}>
              <img src={ImagePaths.LabViewButton.default} alt="View" className='eMed_action_img' />
            </Button>
          </Tooltip>
        </Box>
      }]
    return (
      <Box component={'div'} className='eMed_rts_container'>
        <div className='eMed_Purchase_Table_top'>
          <FormControl sx={{ marginLeft: "1.5vw", display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <RadioGroup
              value={this.state.DrugTypeFilter}
              sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
              onChange={(e) => {
                this.setState({ DrugTypeFilter: e.target.value }, () => {
                  this.getStockList()
                })
              }}
              emed_tid='active_inactive_filter'
            >
              <FormControlLabel value={"all"} control={<Radio size='small' />} label="All" />
              <FormControlLabel value={"active"} control={<Radio size='small' />} label="Active Drugs" />
              <FormControlLabel value={"inactive"} control={<Radio size='small' />} label="Inactive Drugs" />
            </RadioGroup>
          </FormControl>
          {/* {userAccess?.editAccess ? <><Button emed_tid='new_drug' className='eMed_Filter_Btns' variant='contained' size='small'
            onClick={() => { this.props.history.push({ pathname: "/PharmacyInventory/StockList/AddNewDrug" })}}
          >{t(`Add NewDrug`)}</Button>
          <Divider orientation='vertical' /></> : null} */}
          {((this.state.isMainPharma && this.state.phList.length > 0) || this.state.subLocData.length > 0) ? <Tooltip title="Filter" placement='top' arrow>
            <Button emed_tid='st_filter' className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
              <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
            </Button>
          </Tooltip> : null}
          <Tooltip title="Print" placement='top' arrow>
            <Button emed_tid='st_print' className='eMed_usrconf_btn' disabled={this.state.disableBtn} onClick = {() => this.printStockList()}>
              <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
            </Button></Tooltip>
          <Tooltip title="Export" placement='top' arrow>
            <Button emed_tid='st_export' className='eMed_usrconf_btn' disabled={this.state.disableBtn} onClick = {() => this.getStockListExcel()}>
              <img src={ImagePaths.LabUploadButton.default} alt="upload" className='eMed_action_img' />
            </Button></Tooltip>
        </div>
        <Box component={'div'} className='eMed_rts_table'>
          <DataGrid
            rows={this.state.StockList}
            columns={columns}
            getRowId={(row) => row['serial']}
            page={this.state.page}
            pageSize={this.state.pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'>
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
            onPageChange={(newPage) => { this.setState({ page: newPage,selectedPage:newPage }, () => {this.getStockList()}) }}
            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize }, () => this.getStockList())}
            rowsPerPageOptions={[10, 20, 30]}
            rowCount={this.state.rowCount}
            pagination
            paginationMode='server'
            headerHeight={40}
            disableSelectionOnClick
            loading={this.state.isLoader}
            filterMode="server"
            onFilterModelChange={this.onFilterChange}
          />
        </Box>
        {this.renderStockEditPopUp()}
        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
        >
          {this.renderFilterScreen()}
        </Drawer>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
      </Box>
    )
  }
}

export default withTranslation()(PharmaStockList)